import React from 'react';
import { 
  CheckCircleIcon,
  ChartBarIcon,
  CloudIcon,
  ShieldCheckIcon,
  ClockIcon,
  UserGroupIcon,
  DocumentTextIcon,
  CogIcon
} from '@heroicons/react/24/outline';

const MaltaBenefitsGrid = ({ benefits, title = "Key Benefits" }) => {
  const iconMap = {
    'check': CheckCircleIcon,
    'chart': ChartBarIcon,
    'cloud': CloudIcon,
    'shield': ShieldCheckIcon,
    'clock': ClockIcon,
    'users': UserGroupIcon,
    'document': DocumentTextIcon,
    'cog': CogIcon
  };

  return (
    <div className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <h2 className="text-3xl font-extrabold text-gray-900 sm:text-4xl">
            {title}
          </h2>
          <p className="mt-4 text-lg text-gray-600">
            Everything you need to streamline your payroll process
          </p>
        </div>
        
        <div className="mt-12 grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3">
          {benefits.map((benefit, index) => {
            const IconComponent = iconMap[benefit.icon] || CheckCircleIcon;
            
            return (
              <div key={index} className="relative">
                <div className="flex items-center">
                  <div className="flex-shrink-0">
                    <div className="flex items-center justify-center h-12 w-12 rounded-md bg-orange-500 text-white">
                      <IconComponent className="h-6 w-6" aria-hidden="true" />
                    </div>
                  </div>
                  <div className="ml-4">
                    <h3 className="text-lg font-medium text-gray-900">
                      {benefit.title}
                    </h3>
                    <p className="mt-2 text-base text-gray-500">
                      {benefit.description}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default MaltaBenefitsGrid;

